if (!customElements.get('if-product-sticky')) {
  customElements.define('if-product-sticky', class extends HTMLElement {
    connectedCallback() {
      this.product = this.closest('product-info');
      if (!this.product) return;
      this.form = this.product.querySelector(`#product-form-${CSS.escape(this.dataset.section)}`);
      this.buy = this.product.querySelector(`#ProductSubmitButton-${CSS.escape(this.dataset.section)}`);
      this.button = this.querySelector('[data-sticky-add]');
      this.selector = this.querySelector('[data-sticky-variant]');
      this.abort = new AbortController();
      if (!this.buy || !this.form) return;
      const syncButton = () => { this.button.disabled = this.buy.disabled || this.buy.getAttribute('aria-disabled') === 'true'; };
      this.buttonObserver = new MutationObserver(syncButton);
      this.buttonObserver.observe(this.buy, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      syncButton();
      this.button.addEventListener('click', () => {
        if (this.dataset.action === 'scroll' || this.buy.disabled || !this.form.checkValidity()) {
          this.product.querySelector('.if-product-variants, .product-form__quantity, .if-product-buy')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        this.form.requestSubmit(this.buy);
      }, { signal: this.abort.signal });
      this.selector?.addEventListener('change', () => {
        const chosen = this.selector.selectedOptions[0];
        const values = JSON.parse(chosen.dataset.options || '[]');
        const picker = this.product.querySelector('variant-selects');
        if (!picker) return;
        const groups = [...picker.querySelectorAll('fieldset, .product-form__input--dropdown')];
        let last = null;
        groups.forEach((group, index) => {
          const value = values[index];
          if (value == null) return;
          const input = [...group.querySelectorAll('input[type=radio]')].find(el => el.value === value);
          const select = group.querySelector('select');
          if (input) { input.checked = true; last = input; }
          else if (select) {
            select.value = value;
            [...select.options].forEach(option => option.toggleAttribute('selected', option.value === value));
            last = select;
          }
        });
        last?.dispatchEvent(new Event('change', { bubbles: true }));
        this.button.disabled = true;
      }, { signal: this.abort.signal });
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data.sectionId !== this.dataset.section) return;
        const variant = data.variant;
        this.button.disabled = !variant?.available;
        if (variant) {
          if (this.selector) this.selector.value = String(variant.id);
          const image = this.querySelector('.if-product-sticky__image');
          const variantImage = this.selector?.selectedOptions[0]?.dataset.image;
          if (image && (variantImage || this.dataset.defaultImage)) {
            image.removeAttribute('srcset');
            image.src = variantImage || this.dataset.defaultImage;
          }
          const price = this.querySelector('[data-sticky-price]');
          const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(amount / 100);
          if (price) price.textContent = money(variant.price);
          const compare = this.querySelector('[data-sticky-compare]');
          const saving = this.querySelector('[data-sticky-saving]');
          const onSale = variant.compare_at_price > variant.price;
          if (compare) {
            compare.hidden = !onSale;
            if (onSale) compare.textContent = money(variant.compare_at_price);
          }
          if (saving) {
            const style = this.dataset.savingStyle || 'percent';
            saving.hidden = !onSale || style === 'none';
            if (onSale) {
              const amount = money(variant.compare_at_price - variant.price);
              const percent = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
              saving.textContent = style === 'text'
                ? (this.dataset.savingText || '').replaceAll('[percent]', percent).replaceAll('[amount]', amount)
                : style === 'amount' ? `SAVE ${amount}` : `SAVE ${percent}%`;
            }
          }
        }
      });
      if (this.dataset.showAfter === 'gallery') {
        const gallery = this.product.querySelector('media-gallery');
        const columns = this.product.querySelector('.product');
        const updateFromGallery = () => {
          if (!gallery || !columns) return;
          const galleryEnd = window.scrollY + columns.getBoundingClientRect().top + gallery.getBoundingClientRect().height;
          this.hidden = window.scrollY < galleryEnd;
        };
        window.addEventListener('scroll', updateFromGallery, { passive: true, signal: this.abort.signal });
        window.addEventListener('resize', updateFromGallery, { passive: true, signal: this.abort.signal });
        updateFromGallery();
      } else {
        this.observer = new IntersectionObserver(entries => {
          const entry = entries[0];
          this.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        }, { threshold: 0 });
        this.observer.observe(this.buy);
      }
    }
    disconnectedCallback() { this.abort?.abort(); this.unsubscribe?.(); this.observer?.disconnect(); this.buttonObserver?.disconnect(); }
  });
}
